import React, { useEffect, useRef } from 'react';
import homepageVideo from '../../assets/homepage.mp4';
import videoTextImg from './images/videoTextImg.svg';
import videoPoster from './images/videoPoster.jpg';
import './video.css';

export const FullScreenVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.scrollY === 0) {
        videoRef.current.style.height = `${window.innerHeight}px`;
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      ref={videoRef}
      style={{ overflow: 'hidden', height: '100vh', position: 'relative' }}
    >
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 3,
        }}
      >
        <img
          style={{ maxWidth: 800, width: '45%', minWidth: 640 }}
          src={videoTextImg}
          alt=""
        />
      </div>
      <div className="video-container">
        <video
          poster={videoPoster}
          src={homepageVideo}
          autoPlay
          muted
          loop
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        ></video>
      </div>
    </div>
  );
};
